import z from "zod/v4";

export const RestartWorkflowRequestBodyDtoSchema = z.object({
  sessionId: z.uuid(),
  restartFromTimestamp: z.number(),
});

export type RestartWorkflowRequestBodyDto = z.infer<
  typeof RestartWorkflowRequestBodyDtoSchema
>;

export const RestartWorkflowPathParamDtoSchema = z.object({
  sessionId: z.uuid(),
});

export type RestartWorkflowPathParamDto = z.infer<
  typeof RestartWorkflowPathParamDtoSchema
>;
